import {createSlice, PayloadAction} from "@reduxjs/toolkit";
interface IUpdate {
    store: string[]
    update: unknown
}
interface IRemove {
    remove: string[]
}
type FirebaseState = { [key: string]: unknown };

const initialState = {
} as FirebaseState;

const slice = createSlice({
    name: "firebase",
    initialState,
    reducers: {
        remove(state, action: PayloadAction<IRemove>) {
            const path = [...action.payload.remove];
            let root = state;
            let member = path.shift() as string;

            while (path.length) {
                if (root[member] !== undefined) {
                    root = root[member] as FirebaseState;
                    member = path.shift() as string;
                } else {
                    break;
                }
            }
            if (path.length === 0) {
                delete root[member];
            }
        },
        update(state, action: PayloadAction<IUpdate>) {
            const path = [...action.payload.store];
            let root = state;
            let branch: unknown = action.payload.update;
            let member = path.shift() as string;

            while (path.length) {
                if (root[member] !== undefined) {
                    root = root[member] as FirebaseState;
                    member = path.shift() as string;
                } else {
                    break;
                }
            }
            while (path.length) {
                branch = {[path.shift() as string]: branch}
            }
            root[member] = branch;
        },
    }
});

export const {remove, update} = slice.actions;
export default slice.reducer;